/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  const infoBarInner = document.querySelector('.info-bar__inner');
  const mobileItems = document.querySelectorAll('.info-bar__item-mobile');
  const totalMobileItems = mobileItems.length;
  let currentIndex = 0;
  let timer = null;
  let isMobileView = window.innerWidth <= 999;
  let swipeStartListener = null;
  let swipeEndListener = null;
  let navClickListeners = [];

  // Only initialize if mobile items exist
  if (totalMobileItems === 0) return;

  function setupInfoBarSlider() {
    if (isMobileView && infoBarInner && totalMobileItems > 1) {
      // Enable slider for mobile view
      initTimer();
      setupSwipeListeners();
      setupNavButtons();
      toggleNavButtonsVisibility(true);
      enableSliderFunctionality();
    } else {
      // Disable slider for desktop view
      disableSliderFunctionality();
      toggleNavButtonsVisibility(false);
    }
  }

  function enableSliderFunctionality() {
    // Add slider class to enable CSS transitions
    if (infoBarInner) {
      infoBarInner.classList.add('slider-enabled');
    }
  }

  function disableSliderFunctionality() {
    // Clear any running timer
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    
    // Reset position
    if (infoBarInner) {
      infoBarInner.style.transform = '';
      infoBarInner.classList.remove('slider-enabled');
    }
    
    // Remove event listeners
    removeSwipeListeners();
    removeNavButtonListeners();
    
    // Reset current index
    currentIndex = 0;
  }

  function toggleNavButtonsVisibility(visible) {
    const navButtons = document.querySelectorAll('.info-bar__nav-left, .info-bar__nav-right');
    navButtons.forEach(button => {
      button.style.display = visible ? 'block' : 'none';
    });
  }

  function initTimer() {
    if (timer) {
      clearInterval(timer);
    }
    
    timer = setInterval(nextSlide, 5000);
  }

  function showSlide(index) {
    if (!isMobileView) return; // Don't slide if not in mobile view
    
    const translateX = -index * 100;
    infoBarInner.style.transform = `translateX(${translateX}%)`;
  }

  function nextSlide() {
    if (!isMobileView) return; // Don't slide if not in mobile view
    
    currentIndex = (currentIndex + 1) % totalMobileItems;
    showSlide(currentIndex);
    initTimer();
  }

  function prevSlide() {
    if (!isMobileView) return; // Don't slide if not in mobile view
    
    currentIndex = (currentIndex - 1 + totalMobileItems) % totalMobileItems;
    showSlide(currentIndex); 
    initTimer();
  }

  function setupSwipeListeners() {
    // Remove any existing listeners first
    removeSwipeListeners();
    
    // Setup new listeners
    swipeStartListener = function(e) {
      const startX = e.touches[0].clientX;
      
      // Store start position in the element
      this.dataset.startX = startX;
      
      // Pause the timer during swipe
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    
    swipeEndListener = function(e) {
      const startX = parseFloat(this.dataset.startX || 0);
      const endX = e.changedTouches[0].clientX;
      const diffX = startX - endX;

      if (diffX > 30) {
        nextSlide();
      } else if (diffX < -30) {
        prevSlide();
      } else {
        // Restart timer if no slide change
        initTimer();
      }
    };
    
    infoBarInner.addEventListener('touchstart', swipeStartListener, { passive: true });
    infoBarInner.addEventListener('touchend', swipeEndListener);
  }

  function removeSwipeListeners() {
    if (infoBarInner) {
      if (swipeStartListener) {
        infoBarInner.removeEventListener('touchstart', swipeStartListener);
      }
      if (swipeEndListener) {
        infoBarInner.removeEventListener('touchend', swipeEndListener);
      }
    }
  }

  function setupNavButtons() {
    // Remove existing listeners first
    removeNavButtonListeners();
    
    const leftNav = document.querySelector('.info-bar__nav-left');
    const rightNav = document.querySelector('.info-bar__nav-right');
    
    if (leftNav) {
      const leftClickListener = function(e) {
        e.preventDefault();
        prevSlide();
      };
      
      leftNav.addEventListener('click', leftClickListener);
      navClickListeners.push({ element: leftNav, listener: leftClickListener });
    }
    
    if (rightNav) {
      const rightClickListener = function(e) {
        e.preventDefault();
        nextSlide();
      };
      
      rightNav.addEventListener('click', rightClickListener);
      navClickListeners.push({ element: rightNav, listener: rightClickListener });
    }
  }

  function removeNavButtonListeners() {
    navClickListeners.forEach(item => {
      item.element.removeEventListener('click', item.listener);
    });
    navClickListeners = [];
  }

  // Add CSS to document head
  const style = document.createElement('style');
  style.textContent = `
    .info-bar__inner {
      transition: transform 0.3s ease;
    }
    .info-bar__inner.slider-enabled .info-bar__item-mobile {
      flex: 0 0 100%;
      max-width: 100%;
    }
    @media screen and (min-width: 1000px) {
      .info-bar__inner {
        transform: none !important;
      }
    }
  `;
  document.head.appendChild(style);

  // Initial setup
  setupInfoBarSlider();

  // Handle resize events
  window.addEventListener('resize', function() {
    const wasInMobileView = isMobileView;
    isMobileView = window.innerWidth <= 999;
    
    // Only run setup if we're crossing the mobile/desktop threshold
    if (wasInMobileView !== isMobileView) {
      setupInfoBarSlider();
    }
  });
});

document.querySelectorAll('a[href="#cookiebot"]').forEach(link => {
  link.addEventListener('click', function(event) {
      event.preventDefault();
      Cookiebot.renew();
  });
});


// Detect Rebuy cart open/close events
document.addEventListener('DOMContentLoaded', function() {
  
  // Watch for class changes on the cart element
  const cartObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        const cart = document.getElementById('rebuy-cart');
        if (cart) {
          const isVisible = cart.classList.contains('is-visible');
          if (isVisible) {
            // console.log('Cart opened (detected via class change)');
            
            // Save the current scroll position when cart opens
            // But don't change the scroll position - just save it for later
            window.rebuyScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            
            // Add the fixed position to body without scrolling
            document.body.style.top = `-${window.rebuyScrollPosition}px`;
            document.body.classList.add('rebuy-cart-open');
            
          } else {
            // console.log('Cart closed (detected via class change)');
            document.body.classList.remove('rebuy-cart-open');
            
            // Get the scroll position from the body's top property
            const scrollY = document.body.style.top;
            document.body.style.top = '';
            
            // Restore scroll position when cart closes (immediately)
            if (scrollY) {
              window.scrollTo({
                top: parseInt(scrollY || '0') * -1,
                behavior: 'auto'
              });
            }
            
          }
        }
      }
    });
  });
  
  // Start observing
  const observeCart = function() {
    const cart = document.getElementById('rebuy-cart');
    if (cart) {
      cartObserver.observe(cart, { attributes: true });
    }
  };
  
  // Initial setup
  observeCart();


  // Add CSS to prevent body scrolling when cart is open
  const rebuyCartStyle = document.createElement('style');
  rebuyCartStyle.textContent = `
    body.rebuy-cart-open {
      position: fixed;
      width: 100%;
      overflow: hidden;
      /* Don't set height to 100% to avoid dimension changes */
    }
    
    #rebuy-cart {
      overflow-y: auto;
      position: fixed;
      z-index: 999999;
    }
  `;
  document.head.appendChild(rebuyCartStyle);
  
  // Watch for cart element being added to the DOM if not present initially
  if (!document.getElementById('rebuy-cart')) {
    const bodyObserver = new MutationObserver(function(mutations) {
      if (document.getElementById('rebuy-cart')) {
        observeCart();
        bodyObserver.disconnect();
      }
    });
    
    bodyObserver.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  }
});